export class PsWorker {

    _id; // number
    _dni; // string
    _name; // string
    _lastName; // string

    constructor(
        id,
        dni,
        name,
        lastName,
    ) {
        this._id = id;
        this._dni = dni;
        this._name = name;
        this._lastName = lastName;
    }

    static fromAPIWorker(worker) {
        return new this(
            worker.id,
            worker.dni,
            worker.name || '',
            worker.last_name || '',
        );
    }

    id() {
        return this._id;
    }

    dni() {
        return this._dni;
    }

    name() {
        return this._name;
    }

    lastName() {
        return this._lastName;
    }

    completeName() {
        return `${this.name()} ${this.lastName()}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/document/shared/PsWorker.js